import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import routeConfiguration from '../routeConfiguration';
import { matchPathname } from '../util/routes';

/**
 * Returns the name of the route matching the current URL, e.g. "SearchPage".
 * Same value pages pass to Topbar as the currentPage prop.
 */
export const useCurrentPage = () => {
    const { pathname } = useLocation();

    return useMemo(() => {
        const [match] = matchPathname(pathname, routeConfiguration());

        return match?.route?.name;
    }, [pathname]);
};
